import { render } from "./Acusto.vue?vue&type=template&id=9dc79950&scoped=true"
import script from "./Acusto.vue?vue&type=script&lang=js"
export * from "./Acusto.vue?vue&type=script&lang=js"

import "./Acusto.vue?vue&type=style&index=0&id=9dc79950&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dursu\\Desktop\\projebaum\\güncelbaumind-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dc79950"]])

export default __exports__